/** @format */

import React from "react";
import { Security, LoginCallback } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { useOktaAuth } from "@okta/okta-react";
import Login from "../login/Login";
import { Route, Routes, useNavigate, Navigate } from "react-router-dom";
import UserRegistration from "../user/UserRegistration";
// import { pagesList } from "./routes";
import { config } from "../../env";
// import AddPoll from "../poll/AddPoll";
// import EditPoll from "../poll/EditPoll";

import Landing from "../landing/Landing";
// import {ROUTES} from "../../utils/common"
// import LoginLoading from "../login/LoginLoading";
// import SignInLoader from "../login/SignInLoader";

const SecureRoute = ({ children }) => {
  const { authState } = useOktaAuth();
  if (!authState) return null;
  return authState.isAuthenticated ? children : <Navigate to='/login' />;
};

const oktaAuth = new OktaAuth(config.oidc);
function AppWithRouterAccess() {
  const navigate = useNavigate();
  const triggerLogin = () => {
    navigate("/login");
  };

  const customAuthHandler = async () => {
    const previousAuthState = oktaAuth.authStateManager.getAuthState();
    if (!previousAuthState || !previousAuthState.isAuthenticated) {
      // App initialization stage
      triggerLogin();
    } else {
      // Ask the user to trigger the login process during token autoRenew process
    }
  };
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || "/", window.location.origin), { replace: true });
  };
  // const onAuthResume = async () => {
  //   navigate("/login");
  // };
  return (
    <div>
      <Security oktaAuth={oktaAuth} onAuthRequired={customAuthHandler} restoreOriginalUri={restoreOriginalUri}>
        <Routes>
          <Route path='/login' element={<Login />} />
          <Route
            path={config.appRedirectUri}
            element={
              <LoginCallback
                errorComponent={(props) => {
                  return (
                    <div>
                      {props.error.error}
                      <div>
                        {props.error.name}-{props.error.errorSummary}
                      </div>
                      <a href='/' onClick={(e) => oktaAuth.signOut()}>
                        Logout
                      </a>
                    </div>
                  );
                }}
              />
            }
            // render={(props) => (
            //   <LoginCallback {...props} onAuthResume={onAuthResume} loadingElement={() => <div>LOADING ......</div>} />
            // )}
          />
          <Route path='/register' element={<UserRegistration />} />
          <Route
            path='/*'
            element={
              <SecureRoute>
                <Landing />
              </SecureRoute>
            }
          />

          {/* <SecureRoute path="/createPoll" element={AddPoll} />
            <SecureRoute path="/editPoll" element={EditPoll} /> */}

          {/* <Redirect from='*' to='/login' /> */}
          <Route path='*' element={<Navigate to='/login' replace />} />
        </Routes>
      </Security>
    </div>
  );
}

export default AppWithRouterAccess;
